import React, { useState, useEffect, useMemo } from 'react';
import { Alert, TouchableOpacity, View } from 'react-native'

import api from "../../../../utils/api"
import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import BottomSheetModal from '../../../../components/BottomSheetModal';
import { UnitAutocomplete } from '../Fees/Fees/AddPaymentModal';
import { useForm } from 'react-hook-form';
import useFormSubmit from '../../../../hooks/useFormSubmit';
import Input from '../../../../components/Forms/Input';
import Button from '../../../../components/Forms/Button';
import BottomSheet from '../../../../components/BottomSheet';
import LabelSwitch from '../../../../components/Forms/LabelSwitch';



export default function TagDetailBottomSheet({
  visible,
  tag,
  communityId,
  onTagEdited,
  onRequestClose,
  hideUnitSelector,
  canDelete=true,
  initialUnitId=null
}) {
  const { control, reset, handleSubmit, setValue, formState: {isDirty}, watch } = useForm();
  const unitId = watch('unit_id')

  useEffect(() => {
    reset({
      name: tag.name,
      active: tag.active,
      unit_id: initialUnitId,
    })
  }, []);

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onTagEdited,
    onError: (error) => {
      console.log(error)
    },
    successToastMessage: `Tag editado`,
    method: 'put',
    endpoint: `/communities/${communityId}/access/tags/${tag.uuid}`,
  })

  const { submitForm: submitDeletion, isSubmitting: isDeleting } = useFormSubmit({
    onSuccess: onTagEdited,
    onError: (error) => { },
    successToastMessage: "Tag eliminado",
    method: "delete",
    endpoint: `/communities/${communityId}/access/tags/${tag.uuid}`,
  })

  const snapPoints = useMemo(() => {
    return [200, 400]
  }, []);


  function onUnitSelected(unit) {
    setValue("unit_id", unit ? unit.uuid : null)
  }

  function confirTagDeletion() {
    Alert.alert('¿Eliminar este tag?', '', [
      {
        text: 'Cancelar',
        onPress: () => { },
        style: 'cancel',
      },
      { text: 'OK', onPress: () => submitDeletion({}) },
    ]);
  }


  return (
    <BottomSheet
      snapPoints={snapPoints}
      visible={visible}
      onRequestClose={onRequestClose}
      showCloseButton={true}
      height={450}
    >
      <View style={tw`px-5 pt-6`}>
        {
          ! hideUnitSelector &&
            <View style={tw`z-20 mb-4`}>
              <Text style={tw`text-gray-500`}>Vivienda asignada</Text>

              <UnitAutocomplete
                communityId={communityId}
                onUnitSelected={onUnitSelected}
                // initialUnitId={tag.unit?.uuid}
                initialUnitId={unitId}
              />
            </View>
        }

        <View style={tw`mb-4`}>
          <Text style={tw`text-gray-500`}>Nombre</Text>
          <Input
            control={control}
            name='name'
            placeholder=''
            style={{ input: `w-50 pl-5` }}
            rules={{ required: true }}
          />
        </View>

        <Text style={tw`text-gray-500 text-lg mb-5`}>Código: {tag.code}</Text>

        <LabelSwitch control={control} label={"Activo"} style={{container: `mb-4`}} name="active" />

        <View style={tw`row justify-between`}>
          {
            canDelete ?
              <TouchableOpacity style={tw``} onPress={confirTagDeletion}>
                <Text style={tw`text-red`}>Eliminar TAG</Text>
              </TouchableOpacity>
            :
              <View></View>
          }
          
          <Button
            label={isSubmitting ? 'Guardando' : 'Guardar'}
            disabled={isSubmitting}//  || !isDirty
            onPress={handleSubmit(submitForm)}
            style={{ label: tw`text-white` }}
          />
        </View>
      </View>
    </BottomSheet>
  )
}